import React from 'react';
import styled from 'styled-components';

import { Typography } from '../../designComponents';

const SeamlessTeamworkStyled = styled.div`
  margin-bottom: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px 30px;
  & .heading {
    font-size: 32px;
    line-height: 40px;
    font-weight: 600;
    margin-bottom: 10px;
    color: ${({ theme }) => theme.colors.landingSecondaryText};
  }
  & .caption {
    font-size: 16px;
    line-height: 20px;
    font-weight: 500;
    margin-bottom: 30px;
    color: ${({ theme }) => theme.colors.secondaryText};
  }
  & .desc {
    font-size: 16px;
    line-height: 27px;
    font-weight: 500;
    margin-bottom: 20px;
    color: ${({ theme }) => theme.colors.secondaryText};
  }

  @media (max-width: 500px) {
    & .heading {
      font-size: 18px;
      line-height: 32px;
      text-align: center;
    }
    & .caption {
      font-size: 14px;
      line-height: 25px;
      text-align: center;
    }
    & .desc {
      font-size: 14px;
      line-height: 25px;
      color: ${({ theme }) => theme.colors.secondaryText};
    }
  }
`;

const SeamlessTeamwork = () => {
  return (
    <SeamlessTeamworkStyled>
      <Typography className="heading">Seamless Teamwork</Typography>
      <Typography className="caption">
        Client, Technician, and Printer Collaboration
      </Typography>
      <Typography className="desc">
        In the collaborative ecosystem of Escapeplan, clients, technicians, and
        printers synergize seamlessly to achieve project excellence. Our
        platform facilitates dynamic teamwork, ensuring that every stakeholder
        plays a vital role in the project lifecycle.
      </Typography>
      <Typography className="desc">
        Clients initiate the process by conveying their vision and requirements
        to technicians, who meticulously translate these into actionable plans.
        Throughout the project, clients maintain open communication channels
        with technicians, providing feedback and clarifications as needed.
      </Typography>
      <Typography className="desc">
        Printers join the collaboration to bring designs to life, meticulously
        adhering to specifications provided by clients and technicians. Through
        streamlined communication channels, printers receive clear instructions
        and promptly deliver high-quality printed materials.
      </Typography>
      <Typography className="desc">
        This three-way collaboration is underpinned by our platform's robust
        features, including real-time notifications, task assignment
        capabilities, and centralized document management. With everyone on the
        same page, projects progress smoothly, ensuring deadlines are met and
        expectations surpassed.
      </Typography>
    </SeamlessTeamworkStyled>
  );
};

export default SeamlessTeamwork;
